var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeMiterlimit":"10","fill":"none","d":"M22.9 3.7l-15.2 16.6-6.6-7.1"}));
}

Checkmark.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
